import { css } from '@emotion/react';
import { useThemedStyles } from '@trinity/chat-components/components/Theme';
import type { Theme as LocalTheme } from '@trinity/chat-components/types/theme';
import { authorSpacing, messageStyles, messageWidth, extendedMessageWidth } from './Message.styles';

const authorWrapCss = css([messageStyles.authorWrap, {
  marginRight: authorSpacing,
}]);

const authorCss = css(messageStyles.author);

const borderCss = (theme: LocalTheme.Theme) => css({
  border: `2px solid ${theme.palette.gray.light2}`,
});

const bodyCss = (theme: LocalTheme.Theme) => {
  return css([messageStyles.body, borderCss(theme), {
    backgroundColor: theme.palette.white.main,
    maxWidth: extendedMessageWidth,
  }]);
};

const rootCss = css([messageStyles.root, {
  justifyContent: 'flex-start',
}]);

const skeletonTextCss = () => css({
  width: messageWidth - 50,
});

const skeletonItemCss = (theme: LocalTheme.Theme) => css({
  height: 22,
  minHeight: 22,
  backgroundColor: theme.palette.skeleton.main,
});

const engagementLabelCss = (theme: LocalTheme.Theme) => css({
  display: 'inline-block',
  padding: '5px 10px',
  border: `1.5px solid ${theme.palette.gray.light1}`,
  borderRadius: '5px',
  background: theme.palette.white.main,
  fontWeight: 500,
  fontSize: 13,
  color: 'black',
  marginBottom: 12,
  marginTop: 0,
  marginRight: 5,
  marginLeft: 0,
  lineHeight: 1.5,
  letterSpacing: 0,
});

export const useStyles = () => useThemedStyles({
  author: authorCss,
  authorWrap: authorWrapCss,
  body: bodyCss,
  root: rootCss,
  engagementLabel: engagementLabelCss,
});

export const usePlaceholderStyles = () => {
  return useThemedStyles({
    author: authorCss,
    authorWrap: authorWrapCss,
    body: bodyCss,
    root: rootCss,
    skeleton: skeletonTextCss,
    skeletonItem: skeletonItemCss,
  });
};